import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./changepassword.css";
import Mobilecommonhead from "../Mobilecommonhead";
import { actualChangePassword } from "../../api/userRequest";
import toast from "react-hot-toast";

function ChangePasswordPage() {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const navigate = useNavigate();

  const handlePasswordChange = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    try {
      const { data } = await actualChangePassword(
        newPassword,
        currentPassword
      );
      toast.success(data.message);
      navigate("/myaccount");
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
    }
  };

  return (
    <>
      <Mobilecommonhead />

      <main className="auth-layout">
        <form className="card" onSubmit={handlePasswordChange}>
          <h1 className="heading">Change Password</h1>

          <div className="input-group">
            <label>Current Password</label>
            <input
              type="password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              required
            />
          </div>

          <div className="input-group">
            <label>New Password</label>
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
          </div>

          <div className="input-group">
            <label>Confirm New Password</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="primary-btn">
            Change Password
          </button>
        </form>
      </main>
    </>
  );
}

export default ChangePasswordPage;
